/** @format */

import {ReactNode} from 'react';

import {HighlightedText, LabelText, Root} from './styles';

interface Props {
  label: string | ReactNode;
  value: string;
  isPositive?: boolean;
  color?: string;
}

const Delta = ({label, isPositive, value, color}: Props) => {
  return (
    <Root>
      <LabelText>{label}</LabelText>
      <HighlightedText isPositive={isPositive} color={color}>
        {value}
      </HighlightedText>
    </Root>
  );
};

export {Delta};
